<script setup lang="ts">
import ChatDiagnosisTemplate from '@/components/templates/ChatDiagnosisTemplate/ChatDiagnosisTemplate.vue';

definePageMeta({
  middleware: 'activation-check',
  layout: 'no-footer',
});
useAppMeta({
  title: 'お金の健康診断をはじめる',
});
</script>

<template>
  <ClientOnly>
    <ChatDiagnosisTemplate />
  </ClientOnly>
</template>
